/**
=========================================================
* Material Dashboard 2 PRO React TS - v1.0.2
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-2-pro-react-ts
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// @mui material components

// Material Dashboard 2 PRO React TS components
import MDBox from "components/MDBox";

// Material Dashboard 2 PRO React TS examples components
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import logo from "assets/images/profile_icon.png";

import { useSelector } from "react-redux";
import { StoreType } from "../types/genericTypes";

import ModalComponent from "components/Modal";
import Footer from "examples/Footer";
import {
  Backdrop,
  Card,
  CardContent,
  CircularProgress,
  Grid,
  TextField,
  Typography,
} from "@mui/material";
import CotizacionPorId from "components/VistaModulos/CotizacionPorId";
import { useCotizacionProveedor } from "hooks/useCotizacionProveedor";
import { useOrdenCompraProveedor } from "hooks/useOrdenCompraProveedor";
import OrdenCompraPorId from "components/VistaModulos/OrdenCompraPorId";

function OrdenCompraProveedor(): JSX.Element {
  const {
    intl,
    procesando,
    isAlertOpen,
    mensajeAlert,
    handleisAlertClose,
    ordenCompra,
    page,
    rowsPerPage,
    idUsuario,
    handleChangePage,
    handleChangeRowsPerPage,
    detallesOrdenCompraPaginados,
    //procesos orden de compra
    procesandoOrdenCompra,
    aceptarOrdenCompra,
    //proceso xml y pdf factura
    factura,
    setFactura,
    handleChangeFactura,
    procesandoValidandoFactura,
    subirPDFFactura,
    validarFacturaOrdenCompra,
  } = useOrdenCompraProveedor();

  return (
    <DashboardLayout>
      <MDBox py={2}>
        <Card>
          <CardContent>
            <Grid
              container
              justifyContent="center"
              alignItems="center"
              sx={{ height: "100%", mt: 1 }}
            >
              <Grid xs={12}>
                <OrdenCompraPorId
                  verOrdenCompra={ordenCompra}
                  procesando={procesando}
                  page={page}
                  rowsPerPage={rowsPerPage}
                  detallesOrdenCompraPaginados={detallesOrdenCompraPaginados}
                  handleChangePage={handleChangePage}
                  handleChangeRowsPerPage={handleChangeRowsPerPage}
                  procesandoOrdenCompra={procesandoOrdenCompra}
                  aceptarOrdenCompra={aceptarOrdenCompra}
                  factura={factura}
                  handleChangeFactura={handleChangeFactura}
                  procesandoValidandoFactura={procesandoValidandoFactura}
                  subirPDFFactura={subirPDFFactura}
                  validarFacturaOrdenCompra={validarFacturaOrdenCompra}
                />
              </Grid>
            </Grid>
          </CardContent>
        </Card>
      </MDBox>

      {/*<Footer />*/}

      <Backdrop
        sx={(theme) => ({ color: "#fff", zIndex: theme.zIndex.drawer + 1 })}
        open={procesando}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
      <ModalComponent handleClose={handleisAlertClose} isOpen={isAlertOpen} key={"alerta"}>
        <Grid container spacing={2} style={{ textAlign: "center" }}>
          <Grid item xs={12}>
            <br />
            <br />
            <p>{mensajeAlert}</p>
          </Grid>
        </Grid>
      </ModalComponent>
    </DashboardLayout>
  );
}

export default OrdenCompraProveedor;
